import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import {Col, Container, Row} from 'react-bootstrap'
import Config from '../pages/school/Config'
import { Footer } from '../components/footers/Footer'
import PreCandidatesSelection from '../pages/school/PreCandidatesSelection'
import CandidatesSelection from '../pages/school/CandidatesSelection'
import RefusedsSelection from '../pages/school/RefusedsSelection'
import GeneralData from '../pages/school/GeneralData'
import RequestsSent from '../pages/school/RequestsSent'
import Dashboard from '../pages/multiSchool/Dashboard'
import { HeaderMultiSchool } from '../components/headers/HeaderMultiSchool'
import MenuMultiSchool from '../components/menus/MenuMultiSchool'
import Profile from '../pages/multiSchool/Profile'
import Tickets from '../pages/candidate/Tickets'
import Process from '../pages/multiSchool/Process'
import Schools from '../pages/multiSchool/Schools'
import EditShool from '../pages/multiSchool/EditSchool'
import CreateSchool from '../pages/multiSchool/CreateSchool'
import BlockedDatabase from '../pages/multiSchool/BlockedDatabase'
import FavouritesDatabase from '../pages/multiSchool/FavouritesDatabase'
import SchoolStaffs from '../pages/multiSchool/SchoolStaffs'
import CreateSelection from '../pages/school/CreateSelection'
import EditSelection from '../pages/school/EditSelection'
import CandidateData from '../pages/school/CandidatesData'

export default function MultiSchoolRouter () {
	const navigate = useNavigate()

	useEffect(() => {
		let token = sessionStorage.getItem('jwt')

		if (token === 'undefined') {
			navigate('/login')
		}
	}, [navigate])

	return (
		<Container className='d-flex contenedor'>
			<div className='menu-lateral d-none d-lg-block'>
				<MenuMultiSchool/>
			</div>
			<div className='contenido'>
				<Row>
					<Col>
						<HeaderMultiSchool/>
					</Col>
				</Row>
				<Row>
					<Col>
						<Routes>
							<Route path="/dashboard" element={<Dashboard/>}/>
							<Route path="/config" element={<Config/>}/>
							<Route path="/profile" element={<Profile/>}/>
							<Route path="/programprocess" element={<CreateSelection/>}/>
							<Route path="/editprocess/:id" element={<EditSelection />}/>
							<Route path="/overviewprocess/:id" element={<GeneralData />}/>
							<Route path="/overviewprocess/:id/precandidates" element={<PreCandidatesSelection />}/>
							<Route path="/overviewprocess/:id/candidates" element={<CandidatesSelection />}/>
							<Route path="/overviewprocess/:id/candidates/:choose" element={<CandidateData />}/>
							<Route path="/overviewprocess/:id/refuseds" element={<RefusedsSelection />}/>
							<Route path="/overviewprocess/:id/requestssent" element={<RequestsSent />}/>
							<Route path="/activeprocesses" element={<Process />}/>
							<Route path="/completedprocesses" element={<Process finished={true}/>}/>
							<Route path="/database/blocked" element={<BlockedDatabase />}/>
							<Route path="/database/favourites" element={<FavouritesDatabase />}/>
							<Route path="/tickets" element={<Tickets/>}/>
							<Route path="/schools" element={<Schools />}/>
							<Route path="/schools/new" element={<CreateSchool />}/>
							<Route path="/schools/:id/edit" element={<EditShool />}/>
							<Route path="/schools/:id/staff" element={<SchoolStaffs />}/>
							<Route path="*" element={<NotFoundPage/>}/>
						</Routes>
					</Col>
				</Row>
				<Row>
					<Col>
						<Footer/>
					</Col>
				</Row>
			</div>
		</Container>
    )
}